"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberFactory = void 0;
const Factory = require("factory.ts");
exports.phoneNumberFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    number: '5554554321',
});
